import React from 'react';
import { PlusCircle, FileText } from 'lucide-react';

/**
 * Компонент с дополнительными параметрами
 */
const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <PlusCircle className="w-5 h-5 mr-2 text-blue-500" />
        Дополнительные параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Дополнительные расходы */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeExtraExpenses"
              checked={formData.includeExtraExpenses}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать дополнительные расходы (подготовительные курсы, учебные поездки и т.д.)
            </span>
          </label>
        </div>

        {/* Параметры дополнительных расходов */}
        {formData.includeExtraExpenses && (
          <>
            <div>
              <label htmlFor="extraExpensesAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Сумма дополнительных расходов (руб.)
              </label>
              <input
                type="text"
                id="extraExpensesAmount"
                name="extraExpensesAmount"
                value={formData.extraExpensesAmount}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.extraExpensesAmount ? 'input-error' : ''}`}
                placeholder="Например, 50 000"
              />
              {errors.extraExpensesAmount && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.extraExpensesAmount}
                </p>
              )}
            </div>

            <div>
              <label htmlFor="extraExpensesDescription" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Описание дополнительных расходов
              </label>
              <input
                type="text"
                id="extraExpensesDescription"
                name="extraExpensesDescription"
                value={formData.extraExpensesDescription}
                onChange={handleInputChange}
                className="form-input w-full"
                placeholder="Например, подготовительные курсы"
              />
            </div>
          </>
        )}

        {/* Налоговый вычет */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeTaxDeduction"
              checked={formData.includeTaxDeduction}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать социальный налоговый вычет за обучение (13% от стоимости обучения, не более 15 600 руб. в год)
            </span>
          </label>
        </div>
      </div>
      
      {formData.includeExtraExpenses && (
        <div className="mt-4 bg-gray-100 dark:bg-gray-700/30 p-3 rounded-lg border border-gray-200 dark:border-gray-600">
          <div className="flex items-start">
            <FileText className="w-5 h-5 text-gray-600 dark:text-gray-400 mr-3 mt-1" />
            <div>
              <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                О дополнительных расходах
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                Помните о расходах на подготовительные курсы, сдачу экзаменов (ЕГЭ, TOEFL, IELTS и др.), 
                приобретение компьютерной техники и другого необходимого оборудования для учебы.
              </p>
            </div>
          </div>
        </div>
      )}
      
      {formData.includeTaxDeduction && (
        <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800">
          <div className="flex items-start">
            <FileText className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
            <div>
              <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
                О налоговом вычете
              </h4>
              <p className="text-xs text-blue-600 dark:text-blue-400">
                В России можно получить социальный налоговый вычет в размере 13% от расходов на обучение, 
                но не более 120 000 рублей в год (т.е. максимальная экономия - 15 600 руб. в год). 
                Вычет можно получить за своё обучение или обучение детей до 24 лет на очной форме обучения.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdditionalParametersSection;